import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchPastAds } from '../lib/cms';
import Lightbox from '../components/Lightbox';

export default function PastAds() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    async function loadData() {
      const data = await fetchPastAds();
      // Sort by sort_order
      const sorted = data.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
      setAds(sorted);
      setLoading(false);
    }
    loadData();
  }, []);

  const handleOpenLightbox = (index) => {
    setLightboxIndex(index);
  };

  const adImages = ads.map(ad => ad.image?.[0]).filter(Boolean);

  return (
    <div className="py-20 bg-white animate-fade-in">
      <Helmet>
        <title>Tidligere Annoncer – HEINE DESIGN</title>
        <meta name="description" content="Se vores tidligere annoncer og præsentationer fra førende danske boligmagasiner, der fremviser vores minimalistiske stålmøbler." />
      </Helmet>

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="space-y-4 mb-16 text-center">
          <span className="text-xs tracking-[0.25em] uppercase text-black font-semibold block">
            Historie & Presse
          </span>
          <h1 className="text-3xl md:text-4xl font-light tracking-tight text-brand-dark uppercase">
            Tidligere Annoncer
          </h1>
          <div className="h-[1px] w-20 bg-black mx-auto" />
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <i className="fa-solid fa-spinner animate-spin text-3xl text-black" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {ads.map((ad, idx) => (
              <div
                key={ad.id}
                onClick={() => handleOpenLightbox(idx)}
                className="group flex flex-col bg-brand-light/30 border border-black rounded-sm overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg"
              >
                <div className="aspect-[3/4] overflow-hidden bg-brand-light relative">
                  <img
                    src={ad.image?.[0]}
                    alt={ad.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-brand-dark/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center text-brand-dark shadow-lg">
                      <i className="fa-solid fa-magnifying-glass-plus text-lg" />
                    </div>
                  </div>
                </div>
                <div className="p-6 space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold tracking-wider text-brand-dark uppercase">
                      {ad.title}
                    </h3>
                    <span className="text-xs font-semibold text-black bg-brand-light px-2.5 py-1 rounded-full">
                      {ad.year}
                    </span>
                  </div>
                  {ad.description && (
                    <div
                      className="text-xs text-brand-charcoal/70 leading-relaxed font-light line-clamp-3"
                      dangerouslySetInnerHTML={{ __html: ad.description }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox
          images={adImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onPrev={() => setLightboxIndex((prev) => (prev - 1 + adImages.length) % adImages.length)}
          onNext={() => setLightboxIndex((prev) => (prev + 1) % adImages.length)}
        />
      )}
    </div>
  );
}
